import axios from 'axios'
import { Message } from 'element-ui'
import { baseUrl } from '@/config/env'

import {
  randomString,
  getAESEncryption,
  getAESDecryption,
  $rsaEncrypt,
  $rsaDecrypt
} from "@/config/encryptionUtil";
import router from '../router';


const localPubkey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCeIEmoXbOZvgCNV67/W/nY2EUfnGX7oKXWqs4Vi4evSvivjNHQAJcqlsj4illtEb0HQWsKtANvSRikdyo9tTiSIsZGB1ocqiYKGXELxgKGm7kWVQh0ZF7XJpF76P29ijUh2fWSiCciOlV11chvDquvdXMNroy+r3LCr8OmmFu6XwIDAQAB";

let randomKey = randomString();

//全局配置根地址
axios.defaults.baseURL = baseUrl
//全局配置超时时间
// axios.defaults.timeout = "8000"


// 全局配置请求拦截器
axios.interceptors.request.use((config) => {
  // config.headers.AESKey = $rsaEncrypt(randomKey);
  // config.headers.RSAKey = getAESEncryption(localPubkey, randomKey);
  // config.headers.Encrypt = getAESEncryption("1", randomKey);
  let localLanguage = sessionStorage.getItem("language");
  // console.log('axios-config',config)
  if (localLanguage === "zh_CN") {
    config.headers.Language = "zhCN";
    // this.$i18n.locale = "zhCN";
  } else if (localLanguage === "en_US") {
    config.headers.Language = "enUS";
    // this.$i18n.locale = "enUS";
  } else {
    config.headers.Language = "enUS";
    // this.$i18n.locale = "enUS";
  }

  const token = localStorage.getItem('token')
  if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.Authorization = "Bear " + token; 
  }
  return config;

}, (error) => {

  return Promise.reject(error);

})


//全局响应拦截器，统一解密
axios.interceptors.response.use((response) => {
  // console.log(response)
  // 判断token是否失效
  // const newTime = parseInt(new Date().getTime() / 1000);
  // const newTime = new Date().getTime();
  // const ExpiresTime = sessionStorage.getItem('LocalTokenExpiresTime');
  // const LocalTokenExpiresTime = new Date(ExpiresTime).getTime()
  // console.log(newTime)
  // console.log(LocalTokenExpiresTime)
  // debugger
  // if (newTime > LocalTokenExpiresTime && ExpiresTime !== null) {
  //   router.push('/')
  // }

  //获取后台返回的信息
  let responseData = response.data;
  // responseData = getAESDecryption(responseData.data, $rsaDecrypt(responseData.aeskey));
  // responseData = JSON.parse(responseData);

  response.data = responseData;

  return response;

}, (error) => {
  // console.log(error)
  console.log('statys' + error.response.status)
  if (error.response.status == '401') {
     router.push('/')
    }
    if(sessionStorage.getItem('language')=='en_US'){
      return Promise.reject('Login Expired, Please Login again');
    }else{
      return Promise.reject('登录过期，请重新登陆');
    }

});


//params请求参数，需要传入一个json
// export const GET = (url = '', params = {}) => {

//   //get请求不需要加密解密取消拦截器
//   axios.interceptors.request.eject(request);
//   axios.interceptors.response.eject(response);

//   return axios.get(url, {
//     params
//   })
// };


//post body数据加密处理
export const POST = (url = '', body = {}, headers = {}) => {
  // body = JSON.stringify(body);
  // body = getAESEncryption(body, randomKey);
  // console.log('header',headers,body)
  return axios.post(url, body,headers)
};



// WEBPACK FOOTER //
// ./src/api/apiBase.js